export default __webpack_public_path__ + "static/08_Goat-70fc492b77b014d0a5995646ef74fb90.png";